export class RateLimitApiError extends Error {
  constructor() {
    super('Too many requests.')
    Object.setPrototypeOf(this, RateLimitApiError.prototype)
  }
}
